import { jsx as _jsx } from "react/jsx-runtime";
// No webm encode of this demo clip is available, so `video.webm` is omitted — MediaContent
// renders whichever `<source>`s are present (webm first when both exist).
export const bannerHeroVideoMedia = {
    video: {
        mp4: 'https://videos.pexels.com/video-files/7657449/7657449-hd_1920_1080_25fps.mp4',
    },
    poster: 'https://placehold.co/1600x900',
};
export const bannerHeroMock = {
    media: {
        image: _jsx("img", { src: "https://placehold.co/1600x900", alt: "", loading: "eager" }),
    },
    title: 'For the craft of finance',
    cta: {
        label: 'Discover Pleo',
        href: '/discover',
    },
};
